import Menu from 'adeliom-menu-js';

const settings = {
    stickyScrollTop: true,
    closeMenuOnScroll: true,
    responsiveBreakpoint: 960,
}

const menu = new Menu(settings);
menu.init();